import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import styled from 'styled-components';
import { useLocale } from '../context/LocaleContext';
import SeoHead from '../components/SeoHead';
import { useT } from '../hooks/useT';

const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.muted};
`;

const Inner = styled.div`
  text-align: center;
`;

const Code = styled.h1`
  font-size: 2.25rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  color: ${({ theme }) => theme.colors.foreground};
`;

const Message = styled.p`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.mutedForeground};
  margin: 0 0 1rem 0;
`;

const HomeLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  &:hover {
    opacity: 0.9;
  }
`;

function NotFound() {
  const location = useLocation();
  const { prependPath } = useLocale();
  const t = useT();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <Wrap>
      <SeoHead title="404 | CiteMatch" noindex />
      <Inner>
        <Code>404</Code>
        <Message>{t('notFound.title')}</Message>
        <HomeLink to={prependPath('/')}>{t('notFound.returnHome')}</HomeLink>
      </Inner>
    </Wrap>
  );
}

export default NotFound;
